import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserCircleIcon } from '@heroicons/react/24/outline';
import { useTranslation } from 'react-i18next';
import { useAuthStore } from '../../store/authStore';
import { usePermissions } from '../../hooks/usePermissions';

const ProfileDropdown: React.FC = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();
  const { t } = useTranslation('common');
  const { hasRole } = usePermissions();
  const [open, setOpen] = useState(false);
  const isInfluencer = user?.userType === 'influencer';
  const isAdmin = hasRole('admin');

  return (
    <div className="relative">
      <button
        onClick={() => setOpen(!open)}
        className={`rounded-full p-1 transition-colors ${open ? 'text-blue-600 bg-blue-100' : 'text-gray-400 hover:text-gray-500'}`}
      >
        <UserCircleIcon className="h-6 w-6" />
      </button>
      {open && (
        <>
          <div className="fixed inset-0 z-40" onClick={() => setOpen(false)} />
          <div className="absolute right-0 top-full mt-1 w-48 bg-white rounded-lg shadow-lg border border-gray-200 z-50 py-1">
            {isAdmin && (
              <>
                <Link to="/admin" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-blue-700 font-medium hover:bg-blue-50">
                  {t('profileDropdown.adminDashboard')}
                </Link>
                <hr className="my-1" />
              </>
            )}
            <Link to="/discovery" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.allCampaigns')}</Link>
            <Link to="/dashboard" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.dashboard')}</Link>
            <Link to={isInfluencer ? '/my-profile/info' : '/host/info'} onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.myInfo')}</Link>
            <Link to={isInfluencer ? '/my-profile/profile' : '/host/business-profile'} onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
              {isInfluencer ? t('profileDropdown.profile') : t('profileDropdown.businessProfile')}
            </Link>
            <Link to={isInfluencer ? '/my-profile/campaigns' : '/campaigns'} onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">
              {isInfluencer ? t('profileDropdown.myApplications') : t('profileDropdown.myCampaigns')}
            </Link>
            <Link to={isInfluencer ? '/my-profile/settlement' : '/host/payment'} onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.settlement')}</Link>
            <hr className="my-1" />
            <Link to="/notice" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.notice')}</Link>
            <Link to="/inquiry" onClick={() => setOpen(false)} className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-50">{t('profileDropdown.inquiry')}</Link>
            <hr className="my-1" />
            <button onClick={() => { if (!window.confirm(t('profileDropdown.logoutConfirm', 'Are you sure you want to logout?'))) return; setOpen(false); logout(); navigate('/'); }} className="block w-full text-left px-4 py-2 text-sm text-red-600 hover:bg-red-50">{t('profileDropdown.logout')}</button>
          </div>
        </>
      )}
    </div>
  );
};

export default ProfileDropdown;
